
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1vqLd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6dc1b5df5ed5c87a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $6dc1b5df5ed5c87a$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': "vzestupn\u011B",
    'fabric.editor.headingLink.copied': "Zkop\xedrov\xe1no!",
    'fabric.editor.headingLink.copyAnchorLink': "Kop\xedrovat odkaz na nadpis",
    'fabric.editor.headingLink.copyAriaLabel': "Kop\xedrovat",
    'fabric.editor.headingLink.descSortingLabel': "sestupn\u011B",
    'fabric.editor.headingLink.failedToCopy': "Kop\xedrov\xe1n\xed se nezda\u0159ilo",
    'fabric.editor.headingLink.noneSortingLabel': "\u017D\xe1dn\xe9",
    'fabric.editor.inlineComment.marker.end': "konec vlo\u017Een\xe9ho koment\xe1\u0159e",
    'fabric.editor.inlineComment.marker.start': "za\u010D\xe1tek vlo\u017Een\xe9ho koment\xe1\u0159e"
};

});


//# sourceMappingURL=cs.24bba331.js.map
